import { render, staticRenderFns } from "./GlobalAdvancedSearchOld.vue?vue&type=template&id=f38a0de4&"
import script from "./GlobalAdvancedSearchOld.vue?vue&type=script&lang=js&"
export * from "./GlobalAdvancedSearchOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports